import React from 'react';
import { connect } from "react-redux";
import { compose } from "redux";
import SavingSnackbar from "../components/common/SavingSnackbar/SavingSnackbar";
import { updateSavingStatus } from "../globalState/app/actions";

export const WithSavingSnackBar = (Component) => {

  const AppendSavingSnackBar = (props) => {
    const { savingStatus, updateSavingStatus, savingErrorMessage } = props

    return (<>
        <Component {...props} />
        <SavingSnackbar status={savingStatus} updateSavingStatus={updateSavingStatus}
                        savingErrorMessage={savingErrorMessage}/>
      </>
    )
  }


  let mapStateToProps = (state) => {
    return {
      savingStatus: state.app.savingStatus,
      savingErrorMessage: state.app.errorMessage
    }
  }


  return compose(connect(mapStateToProps, { updateSavingStatus }))(AppendSavingSnackBar)
}
